// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".whiwM{display:block;margin:8px 0}@media screen and (min-width:400px){.whiwM{margin:16px 0}}.BSiT7{margin:0 8px}@media screen and (min-width:400px){.BSiT7{margin:0 16px}}._3IYBJ{margin:8px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "whiwM",
	"tabs": "BSiT7",
	"body": "_3IYBJ"
};
module.exports = ___CSS_LOADER_EXPORT___;
